import { render, staticRenderFns } from "./projectModal.vue?vue&type=template&id=42804679&scoped=true&"
import script from "./projectModal.vue?vue&type=script&lang=js&"
export * from "./projectModal.vue?vue&type=script&lang=js&"
import style0 from "./projectModal.vue?vue&type=style&index=0&id=42804679&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42804679",
  null
  
)

export default component.exports